<!--
  Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
 
     http://www.apache.org/licenses/LICENSE-2.0
 
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 
   SPDX-License-Identifier: Apache-2.0
-->

<nav class="navbar sticky-top navbar-expand-lg navbar-dark" id="general-navbar">
    <div class="container-fluid">

        <div id="header-logo">
            <a href="/home">
                <img src="assets/images/Tecnalia_Logo_Mini.jpg" draggable="false" alt="Logo" class="logo-img">
            </a>
        </div>

        <div class="collapse navbar-collapse" id="navbar-items">
            <ul class="navbar-nav gap-5 ms-auto">

                @if (this.isAdmin) {
                    <li class="nav-item" (click)="navigateTo('administration')">
                        <a class="nav-link" id="header-item" [ngClass]="{ 'active': selectedRole === 'Administrator' }">
                            {{ 'HEADER.ADMINISTRATOR' | translate }}
                        </a>
                    </li>
                }

                <li class="nav-item" (click)="navigateTo('catalog')">
                    <a class="nav-link" id="header-item" [ngClass]="{ 'active': selectedRole === 'Catalog' }">
                        {{ 'HEADER.CATALOG' | translate }}
                    </a>
                </li>

                <li
                    class="nav-item dropdown"
                    [class.show]="isDropdownMenuMounted"
                    [class.user-dropdown--closing]="isDropdownClosing"
                >
                    <button
                        class="btn btn-primary dropdown-toggle"
                        type="button"
                        (click)="toggleDropdown()"
                        [attr.aria-expanded]="isDropdownOpen && !isDropdownClosing"
                    >
                        {{ this.user?.username }}
                    </button>
                    <ul
                        class="dropdown-menu"
                        [class.show]="isDropdownMenuMounted"
                        [class.dropdown-menu--closing]="isDropdownClosing"
                    >
                        <li>
                            <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling">
                                {{ 'HEADER.LANGUAGE' | translate }}
                            </a>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li>
                            <a class="dropdown-item" id="dropdown-bottom" (click)="logout()">
                                {{ 'HEADER.LOGOUT' | translate }}&nbsp;
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#FB2528" class="bi bi-box-arrow-right" viewBox="0 2 16 16">
                                    <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
                                    <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </div>

    </div>
</nav>

<!-- LANGUAGE OFFCANVAS -->
<div class="offcanvas offcanvas-start language-offcanvas" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
    <div class="offcanvas-header">
        <div>
            <span class="language-offcanvas__eyebrow">{{ 'HEADER.CATALOG' | translate }}</span>
            <h5 class="offcanvas-title" id="offcanvasScrollingLabel">{{ 'HEADER.LANGUAGE' | translate }}</h5>
            <p class="language-offcanvas__subtitle mb-0">{{ 'HEADER.LANGUAGE-SELECTION' | translate }}</p>
        </div>
        <button type="button" class="btn-close language-offcanvas__close" data-bs-dismiss="offcanvas" [attr.aria-label]="'GENERAL.CLOSE' | translate"></button>
    </div>
    <div class="offcanvas-body">
        <ul class="language-menu">
            @for (lang of languages; track lang) {
                <li>
                    <button
                        type="button"
                        class="language-option"
                        [class.language-option--active]="lang.code === currentLang"
                        (click)="changeLang(lang.code)"
                        data-bs-dismiss="offcanvas"
                        [attr.aria-current]="lang.code === currentLang ? 'true' : null">
                        <span class="language-option__flag-shell">
                            <img [src]="'assets/flags/' + lang.flagcode + '.svg'" [alt]="lang.label + ' flag'" width="24" height="24">
                        </span>
                        <span class="language-option__content">
                            <span class="language-option__label">{{ lang.label }}</span>
                            <span class="language-option__code">{{ lang.code | uppercase }}</span>
                        </span>
                        @if (lang.code === currentLang) {
                            <span class="language-option__check" aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.97 11.03a.75.75 0 0 0 1.07-.02l3.992-4.99a.75.75 0 1 0-1.164-.944L7.477 9.417 5.383 7.323a.75.75 0 0 0-1.06 1.06z"/>
                                </svg>
                            </span>
                        }
                    </button>
                </li>
            }
        </ul>
    </div>
</div>